import { IPlainError } from "../../../error/toPlainError";
import { LatLngLiteral } from "leaflet";

type IGeolocationStateStatus =
  | "INACTIVE"
  | "PENDING"
  | "WATCHING"
  | "CHASING"
  | "ERROR";
export const STATE_INACTIVE: IGeolocationStateStatus = "INACTIVE";
export const STATE_PENDING: IGeolocationStateStatus = "PENDING";
export const STATE_WATCHING: IGeolocationStateStatus = "WATCHING";
export const STATE_CHASING: IGeolocationStateStatus = "CHASING";
export const STATE_ERROR: IGeolocationStateStatus = "ERROR";

export const GEOLOCATION_SWITCHED_TO_INACTIVE_STATE =
  "GEOLOCATION_SWITCHED_TO_INACTIVE_STATE";
export const putSwitchGeolocationToInactiveState = (): IAction<void> => ({
  type: GEOLOCATION_SWITCHED_TO_INACTIVE_STATE,
  payload: null,
});

export const GEOLOCATION_SWITCHED_TO_PENDING_STATE =
  "GEOLOCATION_SWITCHED_TO_PENDING_STATE";
export const putSwitchGeolocationToPendingState = (): IAction<void> => ({
  type: GEOLOCATION_SWITCHED_TO_PENDING_STATE,
  payload: null,
});

export const GEOLOCATION_SWITCHED_TO_WATCHING_STATE =
  "GEOLOCATION_SWITCHED_TO_WATCHING_STATE";
export const putSwitchGeolocationToWatchingState = (): IAction<void> => ({
  type: GEOLOCATION_SWITCHED_TO_WATCHING_STATE,
  payload: null,
});

export const GEOLOCATION_SWITCHED_TO_CHASING_STATE =
  "GEOLOCATION_SWITCHED_TO_CHASING_STATE";
export const putSwitchGeolocationToChasingState = (): IAction<void> => ({
  type: GEOLOCATION_SWITCHED_TO_CHASING_STATE,
  payload: null,
});

export const GEOLOCATION_SWITCHED_TO_ERROR_STATE =
  "GEOLOCATION_SWITCHED_TO_ERROR_STATE";
export const putSwitchGeolocationToErrorState = (
  error: IPlainError,
): IAction<IPlainError> => ({
  type: GEOLOCATION_SWITCHED_TO_ERROR_STATE,
  payload: error,
});

export const GEOLOCATION_COORDINATES_RECEIVED =
  "GEOLOCATION_COORDINATES_RECEIVED";
export const putGeolocationCoordinatesReceived = (
  coordinates: LatLngLiteral,
) => ({
  type: GEOLOCATION_COORDINATES_RECEIVED,
  payload: coordinates,
});

export interface IGeolocationState {
  stateStatus: IGeolocationStateStatus;
  error: IPlainError;
  position: LatLngLiteral;
}

const defaultGeolocationState: IGeolocationState = {
  stateStatus: STATE_INACTIVE,
  error: null,
  position: null,
};

export default function geolocationReducer(
  state: IGeolocationState = defaultGeolocationState,
  action: IAction<any>,
): IGeolocationState {
  switch (action.type) {
    case GEOLOCATION_SWITCHED_TO_INACTIVE_STATE:
      return {
        ...state,
        stateStatus: STATE_INACTIVE,
        error: null,
        position: null,
      };
    case GEOLOCATION_SWITCHED_TO_PENDING_STATE:
      return {
        ...state,
        stateStatus: STATE_PENDING,
        error: null,
        position: state.position,
      };
    case GEOLOCATION_SWITCHED_TO_WATCHING_STATE:
      return {
        ...state,
        stateStatus: STATE_WATCHING,
        error: null,
        position: state.position,
      };
    case GEOLOCATION_SWITCHED_TO_CHASING_STATE:
      return {
        ...state,
        stateStatus: STATE_CHASING,
        error: null,
        position: state.position,
      };
    case GEOLOCATION_SWITCHED_TO_ERROR_STATE:
      return {
        ...state,
        stateStatus: STATE_ERROR,
        error: action.payload,
        position: null,
      };
    case GEOLOCATION_COORDINATES_RECEIVED:
      return {
        ...state,
        stateStatus: state.stateStatus,
        error: null,
        position: action.payload,
      };
    default:
      return state;
  }
}
